import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { validateLineItem } from "MODULES/IncomingQuotes/Parts/validate";
import { COMPANY_ID, CONTACT_ID } from "APP_ROOT/constants";

export function validateCompany(company) {
  company.validate(CONTACT_ID, COMPANY_ID).satisfies(rules.required);
}

export default function validate(values) {
  return validator(values, form => {
    form.validateChildren("companies", validateCompany);

    form.validateChild("incoming_quote_line_item", lineItem => {
      validateLineItem(lineItem, values, "incoming_quote_line_item");
    });
  });
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/IncomingQuoteLineItems/CreateMultiVendorQuote/validate.js